module.exports = __webpack_public_path__ + "static/media/contract.45f37dd1.svg";